import { ModalTheme } from './types';

export const defaultModalTheme: ModalTheme = {
  overlay: 'bg-modal-overlay',
  container: 'flex min-h-full items-center justify-center text-center sm:items-center p-0 md:p-4',
  content:
    'py-7 px-10 md:px-16 relative overflow-hidden rounded-lg text-left shadow-xl transition-all my-0 sm:my-8 w-full md:w-[680px] bg-white',
  header: 'flex flex-col justify-between items-center',
  title: 'self-start text-heading text-4xl font-dmsans font-bold',
};

export const pixTheme: ModalTheme = {
  overlay: 'bg-modal-overlay',
  container: 'flex min-h-full items-center justify-center p-0 md:p-4',
  content:
    'relative overflow-visible rounded-lg bg-white shadow-xl transition-all my-0 sm:my-8 w-full md:w-[980px] px-6 py-6 md:px-10 md:py-8',
  header: 'flex items-center justify-between mb-2',
  title: 'text-heading text-2xl md:text-3xl font-dmsans font-bold',
};
